import i18n from 'i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { initReactI18next } from 'react-i18next';

const options = {
  order: ['querystring', 'cookie'],

  lookupCookie: 'NEXT_LOCALE',
  lookupLocalStorage: 'NEXT_LOCALE',
  lookupSessionStorage: 'NEXT_LOCALE',
};

const resources = {
  'pt-BR': {
    translation: {
      'biobar.profile.manage.button': 'Gerenciar conta',
      'biobar.profile.filter.title': 'Filtrar por solução',
      'biobar.profile.filter.select': 'Selecione uma solução',
      'biobar.profile.search.title': 'Localizar empresa',
      'biobar.profile.search.input': 'Busque por nome ou CNPJ',
      'biobar.profile.favoriteproduct.a': 'Editar produto favorito',
      'biobar.profile.companies.empty.title': 'Nada por aqui',
      'biobar.profile.companies.empty.body': 'Nenhum resultado foi encontrado.',
      'biobar.profile.companies.new': 'NOVO',
      'biobar.profile.exit': 'Sair',
      'biobar.locale.title': 'Selecione a plataforma do país que deseja acessar',
      'biobar.modal.identifier.title': 'Acessar',
      'biobar.modal.identifier.p.first-line': 'O estabelecimento ativo não está habilitado na solução escolhida.',
      'biobar.modal.identifier.p.second-line': 'Selecione uma outra empresa para acessar a plataforma:',
      'biobar.modal.identifier.select.placeholder': 'Selecione uma empresa',
      'biobar.button.continue': 'Continuar',
      'biobar.button.cancel': 'Cancelar',
      'biobar.notification.header' : 'Notificações',
      'biobar.notification.header.action' : 'Apenas não lido',
      'biobar.notification.subheader': 'Mais recentes',
      'biobar.notification.subheader.action': 'Marcar tudo como lido',
      'biobar.notification.card.action' : 'Marcar como lido',
      'biobar.notification.empty.title': 'Muito bem!',
      'biobar.notification.empty.body': 'Você não possui novas notificações.',
      'biobar.notification.content.end.title' : 'Isso é tudo',
    }
  },
  'es-AR': {
    translation: {
      'biobar.profile.manage.button': 'Gerenciar cuenta',
      'biobar.profile.filter.title': 'Filtrar por plataforma',
      'biobar.profile.filter.select': 'Seleccione una plataforma',
      'biobar.profile.search.title': 'Encontrar empresa',
      'biobar.profile.search.input': 'Busque por nombre o CUIT',
      'biobar.profile.favoriteproduct.a': 'Editar plataforma favorita',
      'biobar.profile.companies.empty.title': 'Nada por aqui',
      'biobar.profile.companies.empty.body': 'No se encontraron resultados.',
      'biobar.profile.companies.new': 'NUEVO',
      'biobar.profile.exit': 'Salir',
      'biobar.locale.title': 'Seleccione la plataforma del país que desea',
      'biobar.modal.identifier.title': 'Acceder',
      'biobar.modal.identifier.p.first-line': 'La empresa activa no está habilitada en la plataforma elegida.',
      'biobar.modal.identifier.p.second-line': 'Seleccione otra empresa para acceder a la plataforma:',
      'biobar.modal.identifier.select.placeholder': 'Seleccione una empresa',
      'biobar.button.continue': 'Seguir',
      'biobar.button.cancel': 'Cancelar',
      'biobar.notification.header' : 'Notificaciones',
      'biobar.notification.header.action' : 'Solo las no leídas',
      'biobar.notification.subheader': 'Mais recentes',
      'biobar.notification.subheader.action': 'Marcar todo como leido',
      'biobar.notification.card.action' : 'Marcar como leído',
      'biobar.notification.empty.title': 'Muy bien!',
      'biobar.notification.empty.body': 'No posee nuevas notificaciones',
      'biobar.notification.content.end.title' : 'Eso es todo',
    }
  },
  'es-CO': {
    translation: {
      'biobar.profile.manage.button': 'Gerenciar cuenta',
      'biobar.profile.filter.title': 'Filtrar por plataforma',
      'biobar.profile.filter.select': 'Seleccione una plataforma',
      'biobar.profile.search.title': 'Encontrar empresa',
      'biobar.profile.search.input': 'Busque por nombre o NIT',
      'biobar.profile.favoriteproduct.a': 'Editar plataforma favorita',
      'biobar.profile.companies.empty.title': 'Nada por aqui',
      'biobar.profile.companies.empty.body': 'No se encontraron resultados.',
      'biobar.profile.companies.new': 'NUEVO',
      'biobar.profile.exit': 'Salir',
      'biobar.locale.title': 'Seleccione la plataforma del país que desea',
      'biobar.modal.identifier.title': 'Acceder',
      'biobar.modal.identifier.p.first-line': 'La empresa activa no está habilitada en la plataforma elegida.',
      'biobar.modal.identifier.p.second-line': 'Seleccione otra empresa para acceder a la plataforma:',
      'biobar.modal.identifier.select.placeholder': 'Seleccione una empresa',
      'biobar.button.continue': 'Seguir',
      'biobar.button.cancel': 'Cancelar',
      'biobar.notification.header' : 'Notificaciones',
      'biobar.notification.header.action' : 'Solo las no leídas',
      'biobar.notification.subheader': 'Mais recentes',
      'biobar.notification.subheader.action': 'Marcar todo como leido',
      'biobar.notification.card.action' : 'Marcar como leído',
      'biobar.notification.empty.title': 'Muy bien!',
      'biobar.notification.empty.body': 'No posee nuevas notificaciones',
      'biobar.notification.content.end.title' : 'Eso es todo',
    }
  },
  'es-EC': {
    translation: {
      'biobar.profile.manage.button': 'Gerenciar cuenta',
      'biobar.profile.filter.title': 'Filtrar por plataforma',
      'biobar.profile.filter.select': 'Seleccione una plataforma',
      'biobar.profile.search.title': 'Encontrar empresa',
      'biobar.profile.search.input': 'Busque por nombre o RUC',
      'biobar.profile.favoriteproduct.a': 'Editar plataforma favorita',
      'biobar.profile.companies.empty.title': 'Nada por aqui',
      'biobar.profile.companies.empty.body': 'No se encontraron resultados.',
      'biobar.profile.companies.new': 'NUEVO',
      'biobar.profile.exit': 'Salir',
      'biobar.locale.title': 'Seleccione la plataforma del país que desea',
      'biobar.modal.identifier.title': 'Acceder',
      'biobar.modal.identifier.p.first-line': 'La empresa activa no está habilitada en la plataforma elegida.',
      'biobar.modal.identifier.p.second-line': 'Seleccione otra empresa para acceder a la plataforma:',
      'biobar.modal.identifier.select.placeholder': 'Seleccione una empresa',
      'biobar.button.continue': 'Seguir',
      'biobar.button.cancel': 'Cancelar',
      'biobar.notification.header' : 'Notificaciones',
      'biobar.notification.header.action' : 'Solo las no leídas',
      'biobar.notification.subheader': 'Mais recentes',
      'biobar.notification.subheader.action': 'Marcar todo como leido',
      'biobar.notification.card.action' : 'Marcar como leído',
      'biobar.notification.empty.title': 'Muy bien!',
      'biobar.notification.empty.body': 'No posee nuevas notificaciones',
      'biobar.notification.content.end.title' : 'Eso es todo',
    }
  },
  'es-MX': {
    translation: {
      'biobar.profile.manage.button': 'Gerenciar cuenta',
      'biobar.profile.filter.title': 'Filtrar por plataforma',
      'biobar.profile.filter.select': 'Seleccione una plataforma',
      'biobar.profile.search.title': 'Encontrar empresa',
      'biobar.profile.search.input': 'Busque por nombre o RFC',
      'biobar.profile.favoriteproduct.a': 'Editar plataforma favorita',
      'biobar.profile.companies.empty.title': 'Nada por aqui',
      'biobar.profile.companies.empty.body': 'No se encontraron resultados.',
      'biobar.profile.companies.new': 'NUEVO',
      'biobar.profile.exit': 'Salir',
      'biobar.locale.title': 'Seleccione la plataforma del país que desea',
      'biobar.modal.identifier.title': 'Acceder',
      'biobar.modal.identifier.p.first-line': 'La empresa activa no está habilitada en la plataforma elegida.',
      'biobar.modal.identifier.p.second-line': 'Seleccione otra empresa para acceder a la plataforma:',
      'biobar.modal.identifier.select.placeholder': 'Seleccione una empresa',
      'biobar.button.continue': 'Seguir',
      'biobar.button.cancel': 'Cancelar',
      'biobar.notification.header' : 'Notificaciones',
      'biobar.notification.header.action' : 'Solo las no leídas',
      'biobar.notification.subheader': 'Mais recentes',
      'biobar.notification.subheader.action': 'Marcar todo como leido',
      'biobar.notification.card.action' : 'Marcar como leído',
      'biobar.notification.empty.title': 'Muy bien!',
      'biobar.notification.empty.body': 'No posee nuevas notificaciones',
      'biobar.notification.content.end.title' : 'Eso es todo',
    }
  }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: options,
    fallbackLng: 'pt-BR',

    interpolation: {
      escapeValue: false
    }
  });

